<!-- eslint-disable -->
<div id="scanner-controls" class="scanner-container">

  @if (!(scannerInitialized$ | async)) {
    <mat-progress-spinner
      class="page-spinner"
      color="primary"
      mode="indeterminate"
      diameter="100"
      strokeWidth="8"
      aria-label="Scanniner initializing">
    </mat-progress-spinner>
  }

  @else{
    <div
      class="full-grid"
      >
      <mat-card appearance="outlined" class="shadow-1">
        @if (!(selectedSite$ | async)) {
          <h2
            class="siteLabel">
            Enter your site's name or code to search and select your site
          </h2>
        }
        @else {
          <h2
            class="siteLabel">Your documents will be associated with the following site:
          </h2>
        }
        <eca-site-search
          [acl]="siteSelectACE"
          [client]="clientId$ | async"
          [includeAdmin]="false"
          [rowLimit]="+50"
          [masterSearch]="true"
          [siteType]="schoolSiteType"
          (ngModelChange)="siteSelectedCallback($event)"
          [ngModel]="siteInformation$ | async">
        </eca-site-search>
        <div class="form-status-choice">
          @if (showDraftVersionCheckbox$ | async) {
            <mat-checkbox
              [ngModel]="useDraftVersion$ | async"
              (change)="updateFormStatus()"
              matTooltip="When scanning documents, the system will attempt to use the DRAFT version of the form definition.">
              Use Draft Version
            </mat-checkbox>
          }
        </div>
      </mat-card>
    </div>
  }

  <div id="dwtcontrolContainer"></div>

  <div class="mt-3">
    @for (scanBatch of batchStatus$ | async; track $index; let first = $first; let index = $index) {
      <div>
        @if (batchToDisplay === index) {
          <mat-card appearance="outlined"
            class="batch-card">
            <mat-list class="scan-progress">
              <eca-scan-progress-list-item
                [show]="!(scannerInitialized$ | async)"
                text="Scanner Initializing...">
              </eca-scan-progress-list-item>
              <eca-scan-progress-list-item
                icon="scanner"
                [show]="(scannerInitialized$ | async) && first && scanBatch.length === 0"
                [completed]="scanBatch.length > 0"
                [text]="!(selectedSite$ | async) ? 'Please select a site before scanning.' : 'Begin scanning answer documents.'">
                <!-- Run Scan Button -->
                <button mat-button
                  class="scan-button"
                  color="primary"
                  [disabled]="!(selectedSite$ | async) || scanBatch.length > 0 || (scannerBusy$ | async) || scannerSelectorShown || !(activeScanner$ | async)"
                  ecaThrottleClick (throttleClick)="acquireImages()">
                  Scan
                </button>
                <!-- Selected Scanner Text -->
                @if (activeScanner$ | async; as activeScanner) {
                  <span>
                    @if (activeScanner.name && !scannerSelectorShown) {
                      <span>Using {{ activeScanner.name }}
                        @if (activeScanner.driverTypeName) {
                          <span
                          class="driver-type-name">{{ activeScanner.driverTypeName }}</span>
                        }
                      </span>
                    }
                    @if (!activeScanner.name && !scannerSelectorShown) {
                      <span>No scanner selected</span>
                    }
                    @if (scannerSelectorShown) {
                      <span>Select a scanner:</span>
                    }
                  </span>
                }
                <!-- Select Scanner Button Toggle-->
                @if (!scannerSelectorShown) {
                  <button mat-button
                    class="select-source-button"
                    color="basic"
                    [disabled]="scannerBusy$ | async"
                    ecaThrottleClick (throttleClick)="showScannerSelector()">Select Scanner
                  </button>
                }
                @else {
                  <!-- List of Scanners to select -->
                  @for (source of availableScanners$ | async; track $index) {
                    <button mat-button
                      class="source-button"
                      color="basic"
                      [disabled]="scannerBusy$ | async"
                      ecaThrottleClick (throttleClick)="selectScanner(source)">{{ source.name }}
                      @if (source.driverTypeName) {
                        <span
                          class="driver-type-name">
                          {{ source.driverTypeName }}
                        </span>
                      }
                    </button>
                  }
                }
              </eca-scan-progress-list-item>
            @for (step of scanBatch; track $index) {
                <eca-scan-progress-list-item
                  [show]=true
                  [completed]="step.completed"
                  [failed]="step.failed"
                  [details]="step.details"
                  [text]="step.text"
                  [actions]="step.actions">
                </eca-scan-progress-list-item>
              }
              <eca-scan-progress-list-item
                icon="scanner"
                [show]="(scannerInitialized$ | async) && isCurrentBatchCompleted(scanBatch)"
                text="Do you have more to scan?">
                <button mat-button
                  class="scan-button"
                  color="primary"
                  ecaThrottleClick (throttleClick)="scanAgain()">Scan More
                </button>
              </eca-scan-progress-list-item>
            </mat-list>
          </mat-card>
        }
      </div>
    }
  </div>

  @if (apiStatusOffline$ | async) {
    <eca-app-alert
      icon="warning"
      type="warning"
    text="You are unable to maintain a connection to the DRC Local Scanning Server.
      This can result in an inability to monitor the progress of your scans after they are submitted.">
    </eca-app-alert>
  }

  @if ((batchStatus$ | async).length && (batchStatus$ | async)[0].length > 0) {
    <eca-scan-session-review
      >
    </eca-scan-session-review>
  }
</div>
